function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M85.5,20l-7.3-7.7c-2.7-2.9-7.4-2.9-10.1,0l-2.5,2.6l17.4,18.4l2.5-2.6c1.4-1.4,2.1-3.3,2.1-5.3 C87.6,23.3,86.9,21.4,85.5,20z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.6,82l-3.9-4.1l2.3-7.2L18,66.5L12.6,84c-0.5,1.6-0.1,3.3,1.1,4.6c0.8,0.8,1.8,1.3,2.9,1.3c0.5,0,1-0.1,1.4-0.3l16.2-6 l-3.9-4.1L23.6,82z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.1,25.9l-34.2,36c-0.5,0.5-1.1,0.8-1.7,0.8c-0.6,0-1.3-0.3-1.7-0.8c-1-1-1-2.6,0-3.7l34.2-36l-3.5-3.7L20.8,62.1 l1.7,1.8l14,14.7l1.7,1.8l41.4-43.6L69.1,25.9z"
}));

function SvgMyTracker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTracker);
export default __webpack_public_path__ + "static/media/MyTracker.56bd743b.svg";
export { ForwardRef as ReactComponent };